import Vue from 'vue';
import Vuex from 'vuex';
import ServiceApi from '../ServiceApi';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: sessionStorage.getItem('token') || null,
    baseURL: '/api',
    base_socket: 'ws',
    isLogin: sessionStorage.getItem('token') ? true : false,
    usuario: null,
    rol: null,
    usuarioId: null,
    layout: sessionStorage.getItem('token') ? 'dashboard' : 'login',
    image: null,
    topicSocket: null,
    alertas: [],
    permisos: {
      tarjetas: false,
      repuestos: false,
    },
    audio: false,
  },
  getters: {
    getUserId(state) {
      return state.usuarioId;
    },
  },
  mutations: {
    SET_BASE_SOCKET(state, value) {
      state.base_socket = value;
    },
    SET_LAYOUT(state, value) {
      state.layout = value;
    },
    SET_LOGIN(state, value) {
      state.isLogin = value;
    },
    SET_ROL(state, value) {
      state.rol = value;
    },
    SET_AUDIO(state, value) {
      state.audio = value;
    },
    SET_USUARIO(state, value) {
      state.usuario = value;
    },
    SET_USUARIO_ID(state, value) {
      state.usuarioId = value;
    },
    SET_URL_IMAGE(state, value) {
      state.image = value;
    },
    SET_TOPIC_SOCKET(state, value) {
      state.topicSocket = value;
    },
    SET_PERMISOS_USER(state, value) {
      if (value) {
        state.permisos = JSON.parse(value);
      } else {
        state.permisos = { tarjetas: false, repuestos: false };
      }
    },
    SET_ALERTAS(state, value) {
      if (value) {
        value.length > 0
          ? (state.audio = true)
          : (state.audio = false);
        state.alertas = value.length > 0 ? value : [];
      }
    },
    SET_ALERTA(state, value) {
      state.alertas.push(value);
      state.alertas = state.alertas.reverse();
      state.audio = true;
    },
  },
  actions: {
    validateSessionUser({ commit }, data) {
      let dat = {
        token: this.state.token || sessionStorage.getItem('token'),
      };
      return ServiceApi.post('/validate', dat)
        .then(response => {
          // console.log('RESPUESTA:::::', response.data)
          let data = response.data;
          if (data.status) {
            commit('SET_ALERTAS', data.data.alertas);
            commit('SET_LAYOUT', 'dashboard');
            commit('SET_LOGIN', true);
            commit('SET_ROL', data.data.rol);
            commit('SET_USUARIO', data.data.usuario);
            commit('SET_PERMISOS_USER', data.data.permisos);
            commit('SET_USUARIO_ID', data.data.id);
            commit('SET_TOPIC_SOCKET', `user:${data.data.id}`);
            if (data.data.url_imagen != null) {
              commit('SET_URL_IMAGE', data.data.url_imagen);
            } else {
              commit(
                'SET_URL_IMAGE',
                'https://img.icons8.com/bubbles/100/000000/user.png'
              );
            }
          } else {
            sessionStorage.clear();
            commit('SET_LAYOUT', 'login');
            commit('SET_LOGIN', false);
          }
        })
        .catch(err => {
          //console.log('POR EL CATCH::::', err)
          sessionStorage.clear();
          commit('SET_LAYOUT', 'login');
          commit('SET_LOGIN', false);
        });
    },
    login({ commit }, data) {},
  },
});
